import React from 'react';
import { Copy, Trash2, MoreVertical, Clock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface ManualEntryInlineActionsProps {
  onDuplicate?: () => void;
  onDelete?: () => void;
  disabled?: boolean;
  /** When provided, a "Classify overtime" item is shown above the separator */
  onClassifyOvertime?: () => void;
}

export const ManualEntryInlineActions: React.FC<ManualEntryInlineActionsProps> = ({
  onDuplicate,
  onDelete,
  disabled = false,
  onClassifyOvertime,
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          disabled={disabled}
          className="h-8 w-8 hover:bg-accent text-muted-foreground hover:text-foreground"
        >
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {onClassifyOvertime && (
          <>
            <DropdownMenuItem onClick={onClassifyOvertime} disabled={disabled}>
              <Clock className="h-4 w-4 mr-2" />
              Classify overtime
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        )}
        {onDuplicate && (
          <DropdownMenuItem onClick={onDuplicate} disabled={disabled}>
            <Copy className="h-4 w-4 mr-2" />
            Duplicate
          </DropdownMenuItem>
        )}
        {onDelete && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem 
              onClick={onDelete} 
              disabled={disabled}
              className="text-destructive focus:text-destructive"
            >
              <Trash2 className="h-4 w-4 mr-2" />
              Delete
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
